import { Box, useTheme } from "@xcorejs/ui";
import { XcoreTheme } from "design-system/xcore/theme";

export const IndicatorSeparator = () => {
  const theme = useTheme() as XcoreTheme;
  const separatorProps = theme.select.separator;

  return <Box {...separatorProps}></Box>;
};
